import React from 'react';

import PropTypes from 'prop-types';

import { Container, Inner } from './styles';

export const FixedBottomPrechequePopUp = (props) => {
    return (
        <Container data-testid="precheck-send-button-container">
            <Inner isRightAligned={props.isRightAligned}>{props.children}</Inner>
        </Container>
    );
};

FixedBottomPrechequePopUp.propTypes = {
    isPressedAboveMenu: PropTypes.bool,
    isRightAligned: PropTypes.bool,
    children: PropTypes.oneOfType([
        PropTypes.element,
        PropTypes.arrayOf(PropTypes.element),
        PropTypes.any, //TODO
    ]),
};
